import { nomenclators } from '@mep/pae-commons';

export const CACHE_KEY_LIST_BANK_OFFICE = 'bankOffices';
export const CACHE_KEY_BANK_OFFICE = 'bankOffice-one';
export const ROUTE_PATH_BANK_OFFICE = '/configuration/bank-offices';
export const TRANSLATION_PREFIX_BANK_OFFICE = 'bankOffice';
export const SECURITY_KEY_BANK_OFFICE = 'BANK_OFFICE';

const { BPA, BANMET, BANDEC } = nomenclators;

export const BANK_OFFICE_TYPE_APPEARANCE = {
  [BPA]: { color: '#965AFF' },
  [BANMET]: { color: '#17AB70' },
  [BANDEC]: { color: '#338DC8' }
};
